module.exports = __webpack_public_path__ + "img/1-3.1222e3f8.jpg";